import { BasicUser } from "types/topicflow";

import useUserComboboxQuery from "@components/user-combobox/use-user-combobox-query";
import UserCombobox from "@components/user-combobox/user-combobox";
import {
  UserComboboxOption,
  UserComboboxOptionType,
  UserComboboxUserOption,
} from "@components/user-combobox/user-combobox-list";
import { graphqlNone } from "@helpers/constants";

const GoalKeyResultAssignee = ({
  assignee,
  onChange,
}: {
  assignee?: BasicUser | null;
  onChange: (user: UserComboboxUserOption | null) => void;
}) => {
  const emptyOption: UserComboboxOption = {
    id: graphqlNone,
    email: "Unassigned",
    name: "Unassigned",
    avatar: "",
    type: UserComboboxOptionType.USER,
  };
  const selectedUser = assignee
    ? ({
        ...assignee,
        type: UserComboboxOptionType.USER,
      } as UserComboboxUserOption)
    : emptyOption;
  const { loading, options, query, setQuery } = useUserComboboxQuery({
    emptyOption,
    selected: selectedUser,
  });

  return (
    <UserCombobox
      loading={loading}
      query={query}
      value={selectedUser || null}
      options={options}
      onChangeValue={(opt) => {
        if (opt.type === UserComboboxOptionType.USER) {
          onChange(opt);
        }
      }}
      onChangeQuery={setQuery}
      onClearValue={() => onChange(null)}
    />
  );
};

export default GoalKeyResultAssignee;
